var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content category-course-list",class:{
    'electron-course-list': _vm.isElectron,
    'h5-category-course-list': _vm.isH5,
  }},[(!_vm.courseList.length)?_c('el-empty',{attrs:{"description":"暂无内容","image":require('@/assets/img/live-list/empty.png')}}):_c('div',{staticClass:"course-list"},_vm._l((_vm.courseList),function(item){return _c('CourseCard',{key:item.id,attrs:{"courseInfo":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }